import { QualityEventListResponse, QualityEventsGet, QualityEventCreate, QualityEventSync } from '../types';
import { UpdateDueDatePayload } from '../types/updateDueDate';
import api, { createRequestConfig, medtechApi } from './index';

const eventsApi = {
  async getAllEvents(company: number, filterParams?: QualityEventsGet): Promise<QualityEventListResponse | undefined> {
    const res = await api.get(
      `/company/${company}/events`,
      createRequestConfig({
        params: filterParams,
      }),
    );
    return QualityEventListResponse.parse(res.data);
  },

  async getAllEventsMtbe(
    company: number,
    filterParams?: QualityEventsGet,
  ): Promise<QualityEventListResponse | undefined> {
    const res = await medtechApi.post(`/quality-events/${company}/search`, filterParams ?? {});
    return QualityEventListResponse.parse(res.data);
  },

  async createViaMedtech(company: number, payload: QualityEventCreate): Promise<{ id: number }> {
    const response = await medtechApi.post(`/quality-events/${company}/issues`, {
      ...payload,
    });
    return response.data;
  },

  async updateViaMedtech(company: number, eventId: number, payload: QualityEventCreate): Promise<void> {
    const response = await medtechApi.patch(`/quality-events/${company}/issues/${eventId}`, {
      ...payload,
    });
    return response.data;
  },

  async reassignEvent(company: number, eventId: number, ownerId: number): Promise<void> {
    const response = await medtechApi.patch(`/quality-events/${company}/issues/${eventId}/reassign`, {
      owner_id: ownerId,
    });
    return response.data;
  },

  async syncTemplateFields(company_id: number, eventId: number, templateId: number): Promise<QualityEventSync> {
    const response = await medtechApi.post(`/quality-events/${company_id}/issues/sync`, {
      issue_id: eventId,
      workflow_id: templateId,
    });
    return response.data;
  },

  async updateDueDate(company: number, eventId: number, payload: UpdateDueDatePayload): Promise<void> {
    await medtechApi.patch(`/quality-events/${company}/issues/${eventId}/due-date`, payload);
  },
};

export default eventsApi;
